<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div class="relative mb-20 md:mb-0 ">
  <Pagesubtitle subTitle="Present links to customers when they complete your survey." />
  <vx-card title="Edit External Links" class="mb-5 pb-4">
    <p class="mb-3">You can add a maximum of 5 external links.</p>
    <div>
      <div v-for="(option, i) in localExternalLinks" style="background: #F5F5F5;" class="rounded p-5 my-6">
        <div class="overflow-auto">
          <div class="float-left w-1/2 ">
            <vs-input label="Link headline" v-validate="'min:1|max:50'" data-vv-validate-on="blur" data-vv-as="Link Headline'" :name="'Link headline' + i" class="w-full my-2 inline-block" v-model="option.headline" placeholder="Here's a 10% off Coupon" />
            <span class="block text-danger text-sm my-2">{{ errors.first('Link headline' + i) }}</span>
          </div>
          <div class="float-left w-1/2 pl-5">
            <vs-input label="Link URL" v-validate="'url|min:1'" data-vv-validate-on="blur" data-vv-as="Link URL" :name="'Link url' + i" class="w-full my-2 inline-block" v-model="option.url" placeholder="https://yourbusiness.com/coupons/10off" />
            <span class="block text-danger text-sm my-2">{{ errors.first('Link url' + i) }}</span>
          </div>
        </div>
        <div class="py-2">
          <p>Who should see this link?</p>
          <vs-slider class="w-full" :color="getSliderColor(option.ratingScale[0])" :min="0" :max="10" v-model="option.ratingScale" />
          <p class="relative text-sm">Customers who rated <span class="font-medium">{{ getRatingString(option.ratingScale[0],option.ratingScale[1]) }}</span> will see this.</p>
        </div>
        <vs-button type="line" class="ml-5 my-2" icon-pack="feather" icon="icon-trash" icon-after @click="removeLink(i)">Remove Link</vs-button>
      </div>
      <vs-button type="border" class="my-2" v-if="localExternalLinks.length < 5" @click="() => { localExternalLinks.push({headline: '',url:'',ratingScale: [7,10]}) }">+ Add Link</vs-button>
    </div>
  </vx-card>
  <vx-card title="Example" class="mt-5 pb-4 w-1/2">
    <p class="mb-3">This is how your links appear at the end of surveys.</p>
    <img class="w-full" src="@/assets/images/misc/externallinks.png"/>
  </vx-card>
  <savebutton submitText="Save Links" :accept="syncLinks" :goodToGo="formReady" :cancel="cancel" />
</div>
</template>


<script>
import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  data() {
    return {
      currentQuestionText: '',
      questionType: 'openq',
      initialLinks: false,
      localExternalLinks: []
    }
  },
  components: {
    Savebutton,
    Pagesubtitle
  },
  computed: {
    formReady() {
        let hasEmpties = false

        this.localExternalLinks.forEach((l) => {
          if (l.headline === '' || l.url === '') {
            hasEmpties = true
          }
        })

        if (hasEmpties) return false

        if (!(this.errors.any())) {
          if (JSON.stringify(this.localExternalLinks) !== this.initialLinks) {
            return true
          }
        }
        return false

    }
  },
  created() {

    if (this.$store.getters['dash/externalLinks'].length > 0) {
      this.localExternalLinks = []
      let links = this.$store.getters['dash/externalLinks'].slice()
      links.forEach((link, i) => {
        let theLink = {
          headline: link.headline,
          url: link.url,
          ratingScale: link.ratingScale
        }
        this.localExternalLinks.push(theLink)
      });
    } else {
      this.localExternalLinks = [{
        headline: '',
        url: '',
        ratingScale: [7,10]
      }]
    }

    this.initialLinks = JSON.stringify(this.$store.getters['dash/externalLinks'])

  },
  methods: {
    getSliderColor(minRating) {
      return minRating <= 5 ? 'danger' : minRating <= 7 ? 'warning' : 'success'
    },
    getRatingString(min, max) {
      //if (min === 0 && max === 10) return ''
      return min === max ? min : min + ' - ' + max
    },
    cancel() {
      this.$router.push('/dash/surveyflow')
    },
    syncLinks () {

      this.$store.dispatch('dash/SYNC_EXTERNAL_LINKS', this.localExternalLinks).then(() => {

        this.$router.push('/dash/surveyflow')
        this.$vs.notify({
          title: 'External links',
          text: 'Links updated successfully',
          color: 'success',
          time: 4000,
          iconPack: 'feather',
          icon: 'icon-check'
        })

      }).catch((e) => {

        //noconsoleconsole.log(e)
        this.$vs.notify({
          title: 'External links',
          time: 10000,
          text: 'Oops! Something went wrong, and we couldn\'t update your external links. Please try again, or please reach out for support if it happens again.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })

      })

    },
    removeLink(i) {
      this.localExternalLinks.splice(i, 1)
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
/* .fade-leave-active below version 2.1.8 */
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
